import { PomAnswerOption } from "../typings/pom";

const getAnswerOptions = (): PomAnswerOption[] => {
  return [
    {
      score: 1,
      label: "Sangat Tidak Sesuai",
    },
    {
      score: 2,
      label: "Tidak Sesuai",
    },
    {
      score: 3,
      label: "Netral",
    },
    {
      score: 4,
      label: "Sesuai",
    },
    {
      score: 5,
      label: "Sangat Sesuai",
    },
  ];
};

const getAnswerOptionLabels = (score: number | null): PomAnswerOption|undefined => {
  return getAnswerOptions().find(a => a.score === score);
};

export { getAnswerOptions, getAnswerOptionLabels };
